<template>
  <div>
    <div style="text-align: right; margin-bottom: -30px;">
      <i @click="openModalUps" style="font-size: 32px;" class="fa-brands fa-ups btn-ups-csv"></i>
    </div>
    <b-row class="justify-content-center">
      <b-col cols="12" xl="9" md="12">

        <b-card-code>
          <b-row class="flex-grow-1 p-2">
            <!-- Single Item Form Headers -->
            <b-col cols="12" lg="3">
              <label class="d-inline">Empresa*</label>
              <v-select v-model="empresaSelect" :options="empresas" label="nombre" :clearable="false"
                class="mb-2 item-selector-title" placeholder="Seleccionar empresa" v-if="!cargandoFactura" />
              <p v-else>{{ empresaSelect.nombre }}</p>
            </b-col>
            <b-col cols="12" lg="3">
              <label class="d-inline">Categoria*</label>
              <v-select v-model="categoriaSelect" :options="categorias" label="nombre" :clearable="false"
                class="mb-2 item-selector-title" placeholder="Seleccionar empresa" v-if="!cargandoFactura" />
              <p v-else>{{ categoriaSelect.nombre }}</p>
            </b-col>
            <b-col cols="12" lg="2">
              <b-form-group label="Retencion %" label-for="provincia">
                <b-form-input id="provincia" v-model="retencion" trim />
              </b-form-group>


            </b-col>
            <b-col cols="12" lg="2">
              <b-form-group label="IVA %" label-for="provincia">
                <b-form-input id="provincia" v-model="iva" trim />
              </b-form-group>
            </b-col>

            <b-col cols="12" lg="2">
              <b-form-group label="Shipping" label-for="provincia">
                <b-form-input id="provincia" v-model="shipping" trim />
              </b-form-group>


            </b-col>



          </b-row>
        </b-card-code>
      </b-col>
    </b-row>
    <section class="invoice-add-wrapper">
      <b-row class="invoice-add justify-content-center">

        <!-- Col: Left (Invoice Container) -->
        <b-col cols="12" xl="9" md="12">
          <b-form @submit.prevent>
            <b-card no-body class="invoice-preview-card">
              <!-- Header -->
              <b-card-body class="invoice-padding pb-0">

                <div class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0">

                  <!-- Header: Left Content -->
                  <div>
                    <div class="logo-wrapper">
                      <img :src="empresaSelect.image" style="max-width: 100px" alt="">
                    </div>
                    <b-card-text class="mb-25">
                      {{ empresaSelect.nombre }}
                    </b-card-text>
                    <b-card-text class="mb-0">
                      {{ empresaSelect.direccion }}
                    </b-card-text>
                    <b-card-text class="mb-0">
                      {{ empresaSelect.direccion2 }}
                    </b-card-text>
                    <b-card-text class="mb-25">
                      {{ empresaSelect.direccion3 }}
                    </b-card-text>
                    <b-card-text class="mb-0">
                      {{ empresaSelect.cif }}
                    </b-card-text>
                  </div>

                  <!-- Header: Right Content -->
                  <div class="invoice-number-date mt-md-0 mt-2">
                    <div class="d-flex align-items-center justify-content-md-end mb-1">
                      <h4 class="invoice-title">
                        Factura
                      </h4>
                      <b-input-group class="input-group-merge invoice-edit-input-group disabled">
                        <b-input-group-prepend is-text>
                          {{ categoriaSelect.codigo }}
                        </b-input-group-prepend>
                        <b-form-input id="invoice-data-id" v-model="codigoFactura" v-if="!cargandoFactura" />
                        <b-form-input v-else id="invoice-data-id" v-model="codigoFactura" readonly />
                      </b-input-group>


                    </div>
                    <div class="d-flex align-items-center mb-1">
                      <span class="title">
                        Fecha*
                      </span>
                      <flat-pickr v-model="fechaSelect" class="form-control invoice-edit-input" />
                    </div>
                  </div>
                </div>
              </b-card-body>

              <!-- Spacer -->
              <hr class="invoice-spacing">

              <!-- Invoice Client & Payment Details -->
              <b-card-body class="invoice-padding pt-0">
                <b-row class="invoice-spacing">

                  <!-- Col: Invoice To -->
                  <b-col cols="6" xl="4" class="mb-lg-1">
                    <h6 class="mb-2">
                      Factura para:
                    </h6>

                    <!-- Select Client -->
                    <v-select v-if="!facturaRectificativa" v-model="clientSelect" :options="clients" label="nombre"
                      input-id="invoice-data-client" :clearable="false">
                      <template #list-header>
                        <li @click="nuevoClienteModal()" class="add-new-client-header d-flex align-items-center my-50">
                          <feather-icon icon="PlusIcon" size="16" />
                          <span class="align-middle ml-25">Agregar nuevo cliente</span>
                        </li>
                      </template>
                    </v-select>
                    <span v-else>{{ clientSelect.nombre }}</span>

                    <!-- Selected Client -->
                    <div v-if="clientSelect.id != null" class="mt-1">
                      <h6 class="mb-25">
                        {{ clientSelect.nombre }}
                      </h6>
                      <b-card-text class="mb-25">
                        {{ clientSelect.tlf }}
                      </b-card-text>
                      <b-card-text class="mb-25">
                        {{ clientSelect.direccion }}, {{ clientSelect.ciudad }}
                      </b-card-text>
                      <b-card-text class="mb-25">
                        {{ clientSelect.pais }}
                      </b-card-text>
                      <b-card-text class="mb-0">
                        {{ clientSelect.email }}
                      </b-card-text>

                      <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" size="sm" variant="success"
                        style="margin-top: 5px;" @click="editAddresClient()">
                        Editar
                      </b-button>
                    </div>
                  </b-col>

                  <!--Direccion Envio-->
                  <b-col v-if="clientSelect.id != null" cols="6" xl="4" class="mb-lg-1">
                    <h6 class="mb-2">
                      Direccion envio:
                    </h6>

                    <!-- Select Client -->
                    <v-select v-if="!facturaRectificativa" v-model="clientSelectEnvio" :options="clientsEnvio"
                      label="nombre" input-id="invoice-data-client" :clearable="false">
                      <template #list-header>
                        <li @click="nuevoClienteDireccionEnvioModal()"
                          class="add-new-client-header d-flex align-items-center my-50">
                          <feather-icon icon="PlusIcon" size="16" />
                          <span class="align-middle ml-25">Agregar nueva direccion envio</span>
                        </li>
                      </template>
                    </v-select>
                    <span v-else>{{ clientSelectEnvio.nombre }}</span>

                    <div v-if="clientSelectEnvio && clientSelectEnvio.id != 0" class="mt-1">
                      <h6 class="mb-25">
                        {{ clientSelectEnvio.nombre }}
                      </h6>
                      <b-card-text class="mb-25">
                        {{ clientSelectEnvio.tlf }}
                      </b-card-text>
                      <b-card-text class="mb-25">
                        {{ clientSelectEnvio.direccion }}, {{ clientSelectEnvio.ciudad }}
                      </b-card-text>
                      <b-card-text class="mb-25">
                        {{ clientSelectEnvio.pais }}
                      </b-card-text>

                      <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" size="sm" variant="success"
                        style="margin-top: 5px;" @click="editAddresEnvioClient()">
                        Editar
                      </b-button>
                    </div>
                  </b-col>

                </b-row>
              </b-card-body>

              <!-- Items Section -->
              <b-card-body class="invoice-padding form-item-section">
                <div ref="form" class="repeater-form" :style="{ height: trHeight }">
                  <b-row v-for="(item, index) in invoiceData.items" :key="index" ref="row" class="pb-2">

                    <!-- Item Form -->
                    <!-- ? This will be in loop => So consider below markup for single item -->
                    <b-col cols="12">

                      <!-- ? Flex to keep separate width for XIcon and SettingsIcon -->
                      <div class="d-none d-lg-flex">
                        <b-row class="flex-grow-1 px-1">
                          <!-- Single Item Form Headers -->
                          <b-col cols="12" lg="4">
                            Producto
                          </b-col>
                          <b-col cols="12" lg="2">
                            Precio
                          </b-col>
                          <b-col cols="12" lg="1">
                            Cantidad
                          </b-col>
                          <b-col cols="12" lg="1">
                            No Imp
                          </b-col>
                          <b-col cols="12" lg="2">
                            Descuento
                          </b-col>
                          <b-col cols="12" lg="2">
                            Total
                          </b-col>
                        </b-row>
                        <div class="form-item-action-col" />
                      </div>

                      <!-- Form Input Fields OR content inside bordered area  -->
                      <!-- ? Flex to keep separate width for XIcon and SettingsIcon -->
                      <div class="d-flex border rounded">
                        <b-row class="flex-grow-1 p-2">
                          <!-- Single Item Form Headers -->
                          <b-col cols="12" lg="4">
                            <label class="d-inline d-lg-none">Producto</label>
                            <v-select v-model="item.sku" :options="articulosSku" label="sku" :clearable="false"
                              class="mb-2 item-selector-title" placeholder="Select Item"
                              @input="val => updateItemForm(index, val)" />

                          </b-col>
                          <b-col cols="12" lg="2">
                            <label class="d-inline d-lg-none">Precio</label>
                            <b-form-input v-model="item.precio" type="number" class="mb-2" @wheel.prevent />
                          </b-col>
                          <b-col cols="12" lg="1">
                            <label class="d-inline d-lg-none">Cantidad</label>
                            <b-form-input v-model="item.qty" type="number" class="mb-2" @wheel.prevent />
                          </b-col>
                          <b-col cols="12" lg="1">
                            <label class="d-inline d-lg-none">No Imp</label>
                            <b-form-checkbox style="margin-top: 7px;" v-model="item.noimp">
                            </b-form-checkbox>
                          </b-col>
                          <b-col cols="12" lg="2">
                            <label class="d-inline d-lg-none">Descuento</label>
                            <b-form-input v-model="item.descuento" type="text" class="mb-2" />
                          </b-col>
                          <b-col cols="12" lg="2">
                            <label class="d-inline d-lg-none">Total</label>
                            <p class="mb-1">
                              {{ getTotalLine(item) }}
                            </p>
                          </b-col>
                          <b-col cols="12" lg="6"
                            v-if="item.sku != undefined && item.sku.sku != undefined && item.sku.sku == 'Personalizado'">
                            <label class="d-inline d-lg-none">Descripcion</label>
                            <b-form-textarea v-model="item.description" class="mb-2 mb-lg-0" />
                          </b-col>
                        </b-row>
                        <div class="d-flex flex-column justify-content-between border-left py-50 px-25">
                          <feather-icon size="16" icon="XIcon" class="cursor-pointer" @click="removeItem(index)" />
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </div>
                <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" size="sm" variant="primary"
                  @click="addNewItemInItemForm('Personalizado')">
                  Agregar producto
                </b-button>
              </b-card-body>

              <!-- Invoice Description: Total -->
              <b-card-body class="invoice-padding pb-0">
                <b-row>

                  <!-- Col: Total -->
                  <b-col cols="12" md="12" class="mt-md-6 d-flex justify-content-end" order="1" order-md="2">
                    <div class="invoice-total-wrapper">
                      <div class="invoice-total-item">
                        <p class="invoice-total-title">
                          Subtotal:
                        </p>
                        <p class="invoice-total-amount">
                          {{ getSubTotal() }}
                        </p>
                      </div>
                      <div class="invoice-total-item" v-if="hayDescuento">
                        <p class="invoice-total-title">
                          Descuento:
                        </p>
                        <p class="invoice-total-amount">
                          -{{ getDescuento() }}
                        </p>
                      </div>
                      <div class="invoice-total-item" v-if="retencion > 0">
                        <p class="invoice-total-title">
                          Retencion {{ retencion }}%:
                        </p>
                        <p class="invoice-total-amount">
                          -{{ getRetencion() }}
                        </p>
                      </div>
                      <div class="invoice-total-item" v-if="iva > 0">
                        <p class="invoice-total-title">
                          IVA {{ iva }}%:
                        </p>
                        <p class="invoice-total-amount">
                          {{ getIva() }}
                        </p>
                      </div>
                      <div class="invoice-total-item" v-if="shipping > 0">
                        <p class="invoice-total-title">
                          Shipping:
                        </p>
                        <p class="invoice-total-amount">
                          {{ ponerMoneda(shipping) }}
                        </p>
                      </div>
                      <hr class="my-50">
                      <div class="invoice-total-item">
                        <p class="invoice-total-title">
                          Total:
                        </p>
                        <p class="invoice-total-amount">
                          {{ getTotal() }}
                        </p>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </b-card-body>

              <!-- Spacer -->
              <hr class="invoice-spacing">

              <!-- Note -->
              <b-card-body class="invoice-padding pt-0">
                <span class="font-weight-bold">Notas: </span>
                <b-form-textarea v-model="invoiceData.note" />
              </b-card-body>

              <b-row class="flex-grow-1 p-2 justify-content-center">
                <b-col cols="12" lg="8">

                  <v-select v-if="facturaRectificativa" v-model="motivoDevolucion"
                    :options="['R1 Base imponible reducida porque el destinatario no paga o se resuelve la operación', 'R2 Cuando se devuelve envases/embalajes', 'R3 Cuando se produce la modificación por resolución, rescisión o anulación de la operación', 'R4 Corrección de errores materiales, numéricos, etc.']"
                    label="nombre" :clearable="false" class="mb-2 item-selector-title"
                    placeholder="Seleccionar motivo devolución*" />

                </b-col>
              </b-row>

              <!-- Boton guardar (flotante, siempre visible) -->
              <b-card-body class="invoice-padding pt-0 factura-edit-floating-btn" style="text-align: center">
                <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" size="md" variant="primary"
                  @click="guardarFactura()" v-if="!facturaCreada">
                  <span v-if="!facturaCargada && !cargandoFactura">Guardar factura</span>
                  <span v-if="facturaCargada && !cargandoFactura"><span v-if="!facturaDraft">Copiar factura</span><span
                      v-else>Crear
                      de Draft</span></span>
                  <span v-if="facturaCargada && cargandoFactura && !facturaRectificativa">Actualizar factura</span>
                  <span v-if="facturaRectificativa">Crear factura rectificativa</span>
                </b-button>


                <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" size="md" variant="warning" @click="resetFactura()"
                  v-else>
                  Empezar nueva factura
                </b-button>
              </b-card-body>

            </b-card>
          </b-form>
        </b-col>

      </b-row>

      <!--MODAL USUARIO NUEVO -->
      <b-sidebar id="sidebar-invoice-add-new-customer" sidebar-class="sidebar-lg" bg-variant="white" shadow backdrop
        no-header right v-model="showSidebar">
        <template #default="{ hide }">
          <!-- Header -->
          <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
            <h5 class="mb-0">
              <span v-if="!editandoDireccion">Nuevo cliente</span>
              <span v-else>Actualizar cliente</span>
            </h5>

            <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="hide" />

          </div>

          <!-- Body -->
          <b-form class="p-2" @submit.prevent>

            <!-- Customer Name -->
            <b-form-group label="Nombre" label-for="customer-name">
              <b-form-input id="customer-name" v-model="customer.nombre" trim />
            </b-form-group>

            <!-- Cif -->
            <b-form-group label="Cif" label-for="customer-name">
              <b-form-input id="customer-name" v-model="customer.cif" trim />
            </b-form-group>

            <!-- Email -->
            <b-form-group label="Email" label-for="email">
              <b-form-input id="email" v-model="customer.email" trim type="email" />
            </b-form-group>

            <!-- Direccion -->
            <b-form-group label="Direccion" label-for="address">
              <b-form-textarea id="address" v-model="customer.direccion" trim />
            </b-form-group>

            <!-- Ciudad -->
            <b-form-group label="Ciudad" label-for="ciudad">
              <b-form-input id="ciudad" v-model="customer.ciudad" trim />
            </b-form-group>

            <!-- cp -->
            <b-form-group label="CP" label-for="cp">
              <b-form-input id="cp" v-model="customer.cp" trim />
            </b-form-group>

            <!-- Provincia -->
            <b-form-group label="Provincia" label-for="provincia">
              <b-form-input id="provincia" v-model="customer.provincia" trim />
            </b-form-group>

            <!-- Pais -->
            <b-form-group label="Pais" label-for="pais">
              <b-form-input id="pais" v-model="customer.pais" trim />
            </b-form-group>

            <!-- Pais -->
            <b-form-group label="ISO Pais" label-for="pais">
              <b-form-input id="isoPais" v-model="customer.iso" trim />
            </b-form-group>

            <!-- Telefono -->
            <b-form-group label="Telefono" label-for="telefono">
              <b-form-input id="telefono" v-model="customer.tlf" trim />
            </b-form-group>

            <!-- Form Actions -->
            <div class="d-flex mt-2">
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mr-2" type="submit"
                @click="agregarNuevoCliente">
                <span v-if="!editandoDireccion">Agregar</span>
                <span v-else>Guardar</span>

              </b-button>
              <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" variant="outline-secondary" @click="hide">
                Cancelar
              </b-button>
            </div>
          </b-form>
        </template>
      </b-sidebar>

      <!--MODAL Direccion Envio NUEVO -->
      <b-sidebar id="sidebar-invoice-add-new-customer" sidebar-class="sidebar-lg" bg-variant="white" shadow backdrop
        no-header right v-model="showSidebarEnvio">
        <template #default="{ hide }">
          <!-- Header -->
          <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
            <h5 class="mb-0">
              <span v-if="!editandoDireccionEnvio">Nueva dirección envio</span>
              <span v-else>Actualizar dirección envio</span>

            </h5>

            <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="hide" />

          </div>

          <!-- Body -->
          <b-form class="p-2" @submit.prevent>

            <!-- Customer Name -->
            <b-form-group label="Nombre" label-for="customer-name">
              <b-form-input id="customer-name" v-model="customerEnvio.nombre" trim />
            </b-form-group>

            <!-- Cif -->
            <b-form-group label="Cif" label-for="customer-name">
              <b-form-input id="customer-name" v-model="customerEnvio.cif" trim />
            </b-form-group>


            <!-- Direccion -->
            <b-form-group label="Direccion" label-for="address">
              <b-form-textarea id="address" v-model="customerEnvio.direccion" trim />
            </b-form-group>

            <!-- Ciudad -->
            <b-form-group label="Ciudad" label-for="ciudad">
              <b-form-input id="ciudad" v-model="customerEnvio.ciudad" trim />
            </b-form-group>

            <!-- cp -->
            <b-form-group label="CP" label-for="cp">
              <b-form-input id="cp" v-model="customerEnvio.cp" trim />
            </b-form-group>

            <!-- Provincia -->
            <b-form-group label="Provincia" label-for="provincia">
              <b-form-input id="provincia" v-model="customerEnvio.provincia" trim />
            </b-form-group>

            <!-- Pais -->
            <b-form-group label="Pais" label-for="pais">
              <b-form-input id="pais" v-model="customerEnvio.pais" trim />
            </b-form-group>

            <!-- Telefono -->
            <b-form-group label="Telefono" label-for="telefono">
              <b-form-input id="telefono" v-model="customerEnvio.tlf" trim />
            </b-form-group>

            <!-- Form Actions -->
            <div class="d-flex mt-2">
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mr-2" type="submit"
                @click="agregarNuevaDireccionEnvio">
                <span v-if="!editandoDireccionEnvio">Agregar</span>
                <span v-else>Guardar</span>

              </b-button>
              <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" variant="outline-secondary" @click="hide">
                Cancelar
              </b-button>
            </div>
          </b-form>
        </template>
      </b-sidebar>
    </section>

    <b-modal id="modal-ups-csv" title="UPS CSV" centered size="xl" hide-footer class="modal-max-height">
      <b-form-group label="Adjuntar CSV:" label-for="file-input-multi">
        <b-form-file id="file-input-multi" v-model="archivosAdjuntosTemp"
          placeholder="Selecciona o arrastra archivos aquí..." drop-placeholder="Suelta el archivo aquí..."
          accept=".csv" multiple @input="handleFileUpload"></b-form-file>
      </b-form-group>

      <div v-if="adjuntos.length > 0" class="mb-3">
        <div style="text-align: center;">
          <b-button @click="procesarCsvUps">Procesar</b-button>
        </div>
        <h6>CSV adjuntos:</h6>
        <b-list-group>
          <b-list-group-item v-for="(file, index) in adjuntos" :key="index"
            class="d-flex justify-content-between align-items-center list-group-item-sm p-2">
            <span><i class="fa-solid fa-file-csv mr-2"></i> {{ file.name }}</span>

            <b-button variant="danger" size="sm" @click="removeAttachment(index)" class="ml-2" title="Eliminar adjunto">
              <i class="fa fa-times"></i>
            </b-button>
          </b-list-group-item>
        </b-list-group>
      </div>

    </b-modal>
  </div>

</template>

<script>
import { ref, onUnmounted } from '@vue/composition-api'
import { heightTransition } from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import {
  BRow, BCol, BCard, BCardBody, BButton, BCardText, BForm, BFormGroup, BFormInput, BInputGroup, BInputGroupPrepend, BFormTextarea, BFormCheckbox, BPopover, VBToggle,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import axios from '@axios'
import BCardCode from '@core/components/b-card-code'
import { includes } from 'postcss-rtl/lib/affected-props'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BButton,
    BCardText,
    BForm,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BFormTextarea,
    BFormCheckbox,
    BPopover,
    flatPickr,
    vSelect,
    BCardCode,

  },
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  data() {
    return {
      showSidebar: false,
      showSidebarEnvio: false,
      clients: [],
      clientsEnvio: [],
      clientSelect: { id: null },
      clientSelectEnvio: null,
      allClientDirecciones: [],
      lastCif: "",
      empresas: [],
      empresaSelect: { nombre: '', direccion: '', direccion2: '', direccion3: '', cif: '', moneda: '' },
      categorias: [],
      categoriaSelect: { nombre: '', codigo: '' },
      retencion: 0,
      iva: 21,
      shipping: 0,
      articulosSku: [],
      hayDescuento: false,
      fechaSelect: null,
      codigoFactura: "",
      nuevaFactura: true,
      facturaCreada: false,
      articulosParametros: [],
      subtotal: '',
      descuentototal: '',
      retenciontotal: '',
      ivatotal: '',
      lastLenght: 1,
      cargandoFactura: false,
      facturaRectificativa: false,
      copiandoFactura: false,
      facturaCargada: null,
      facturaDraft: false,
      noImp: false,
      facturaAlbaran: false,
      pendientes: [],
      editandoDireccion: false,
      editandoDireccionEnvio: false,
      motivoDevolucion: null,
      adjuntos: [],
      archivosAdjuntosTemp: null,
    }
  },
  mixins: [heightTransition],
  mounted() {
    this.initTrHeight();
    this.loadData();
    window.addEventListener('resize', this.initTrHeight);
  },
  created() {

    const parametro = this.$route.params.parametro;
    this.noImp = this.$route.params.iva21;
    this.facturaAlbaran = this.$route.params.facturaAlbaran;
    this.articulosParametros = parametro;
    this.pendientes = this.$route.params.pendientes;

    //console.log(this.pendientes);
  },
  destroyed() {
    window.removeEventListener('resize', this.initTrHeight)
  },
  methods: {
    loadData() {

      axios.post("/uso", { seccion: "facturaEdit" });
      axios
        .get("/finanzas/cliente")
        .then(response => {
          return response.data;
        })
        .then(res => {
          this.clients = res;

          if (this.facturaAlbaran) {
            this.clientSelect = this.clients[0];
          }
        });

      axios
        .get("/finanzas/cliente/envio")
        .then(response => {
          return response.data;
        })
        .then(res => {

          this.allClientDirecciones = res;

          this.clientsEnvio = [
            { id: 0, nombre: 'Misma dirección factura' },
            ...res.filter(c => c.idCliente === this.clientSelect.id)
          ];

          /*if(this.facturaAlbaran)
          {
            this.clientSelect = this.clients[0];
          }*/
        });

      axios
        .get("/finanzas/empresas")
        .then(response => {
          return response.data;
        })
        .then(res => {
          this.empresas = res;

          if (this.facturaAlbaran) {
            this.empresaSelect = this.empresas[1];
          }
        });

      axios
        .get("/finanzas/categorias")
        .then(response => {
          return response.data;
        })
        .then(res => {
          this.categorias = res;
          if (this.facturaAlbaran) {
            this.categoriaSelect = this.categorias[0];
          }
        });

      axios
        .get("/finanzas/articulos")
        .then(response => {
          return response.data;
        })
        .then(res => {
          this.articulosSku = res;
          this.articulosSku.map(item => item.nombre = item.sku);
          this.articulosSku.unshift({
            confeccion: 0,
            id: -1,
            nombre: '',
            sku: 'Personalizado'
          })


          if (this.articulosParametros != undefined && Array.isArray(this.articulosParametros) && this.articulosParametros.length > 0) {
            //console.log(this.articulosParametros);

            const agrupados = {};

            this.articulosParametros.forEach(arti => {
              if (agrupados[arti.sku]) {
                agrupados[arti.sku].cantidad += arti.cantidad;
              } else {
                agrupados[arti.sku] = { ...arti }; // copia el primer objeto con ese sku
              }
            });

            const articulosUnificados = Object.values(agrupados);

            //this.invoiceData.items = [];
            let contador = 0;

            articulosUnificados.forEach(arti => {
              let skuCortado = arti.sku.replace(/-[^-]+$/, "");

              if (arti.sku.includes('CLOTH-BAG'))
                skuCortado = arti.sku;

              const articuloEncontrado = this.articulosSku.filter(item => item.sku === skuCortado);

              let sku = {}



              if (articuloEncontrado.length > 0) {
                //console.log(articuloEncontrado);
                sku = {
                  confeccion: articuloEncontrado[0].confeccion,
                  id: arti.id,
                  nombre: arti.sku,
                  sku: arti.sku,
                  descuento: 0,
                  description: arti.sku,
                  qty: arti.cantidad,
                  noimp: this.noImp
                };

                /*if(arti.nota != undefined && arti.nota != null && arti.nota != '')
                {
                  sku.nombre += ' | Tracking:' + arti.nota;
                  sku.description += ' ' + arti.nota;
                  sku.noimp = true;
                }*/
              }
              else if ((skuCortado.split('-').pop() == 'NOMAD') || (skuCortado.split('-').pop() == 'DOPP') || (skuCortado.includes('CARD-HOLDER-RFID-HOR'))) {
                let skuCortadoNomadDop = skuCortado.replace(/-[^-]+$/, "");

                const articuloEncontradoNomad = this.articulosSku.filter(item => item.sku === skuCortadoNomadDop);

                if (articuloEncontradoNomad.length > 0) {
                  sku = {
                    confeccion: articuloEncontradoNomad[0].confeccion,
                    id: arti.id,
                    nombre: arti.sku,
                    sku: arti.sku,
                    descuento: 0,
                    description: arti.sku,
                    qty: arti.cantidad,
                    noimp: this.noImp
                  };

                  /*if(arti.nota != undefined && arti.nota != null && arti.nota != '')
                  {
                    sku.nombre += ' | Tracking:' + arti.nota;
                    sku.description += ' ' + arti.nota;
                    sku.noimp = true;
                  }*/

                }

              }
              else {
                sku = {
                  confeccion: 0,
                  id: contador + 10000,
                  nombre: arti.sku,
                  sku: arti.sku,
                  descuento: 0,
                  description: arti.sku,
                  qty: arti.cantidad,
                  noimp: this.noImp
                };

                /*if(arti.nota != undefined && arti.nota != null && arti.nota != '')
                {
                  sku.nombre += ' | Tracking:' + arti.nota;
                  sku.description += ' ' + arti.nota;
                  sku.noimp = true;
                }*/

                this.articulosSku.push(sku);
              }

              //console.log(this.articulosSku);


              this.addNewItemInItemForm();
              this.updateItemForm(contador, sku);

              contador++;
            });
          }
          else if (this.articulosParametros != undefined) {
            this.cargandoFactura = true;

            let idFactura = 0;

            if (this.articulosParametros.includes('-c')) {
              idFactura = this.articulosParametros.split('-')[0];
              this.cargandoFactura = false;
              this.copiandoFactura = true;
            }
            else if (this.articulosParametros.includes('-r')) {
              idFactura = this.articulosParametros.split('-')[0];
              this.cargandoFactura = true;
              this.facturaRectificativa = true;
            }
            else
              idFactura = this.articulosParametros

            axios
              .get("/finanzas/factura/" + idFactura)
              .then(response => {
                return response.data;
              })
              .then(res => {
                this.facturaCargada = res;

                if (res.codigo.includes('DF') && !this.cargandoFactura)
                  this.facturaDraft = true;

                this.invoiceData.note = this.facturaCargada.notas;
                //this.invoiceData = res;

                this.clientSelect = res.cliente;
                this.empresaSelect = res.empresa;

                this.clientsEnvio = [
                  { id: 0, nombre: 'Misma dirección factura' },
                  ...this.allClientDirecciones.filter(c => c.idCliente === this.clientSelect.id)
                ];


                setTimeout(() => {
                  this.clientSelectEnvio = this.clientsEnvio.find(client => client.id === res.idDireccionEnvio);
                }, 500);


                this.retencion = res.retencion;
                this.iva = res.iva;
                this.shipping = res.shipping;

                this.categorias.forEach(categoria => {
                  if (categoria.id == res.idCategoria)
                    this.categoriaSelect = categoria;
                });


                if (this.facturaDraft) {
                  this.categoriaSelect = this.categorias[0];
                }
                else if (this.facturaRectificativa) {
                  this.categoriaSelect = { nombre: 'Rectificativa', codigo: 'A', id: 10 };
                }


                if (this.cargandoFactura) {
                  this.fechaSelect = res.fecha;
                  if (res.codigo != null && res.codigo.includes('DF')) {
                    this.codigoFactura = res.codigo.substring(3);
                  }
                  else if (res.codigo != null && this.facturaRectificativa) {
                    this.obtenerNumero(res.codigo);
                  }
                  else
                    this.codigoFactura = res.codigo.substring(1);
                }

                let contador = 0;

                this.facturaCargada.items.forEach(arti => {

                  let noimp = false;

                  if (arti.noimp) {
                    noimp = true;
                  }

                  let confeccionPrecio = arti.precio;

                  if (this.facturaRectificativa) {
                    confeccionPrecio = -Math.abs(arti.precio);
                  }


                  let cantidadFixeada = arti.cantidad;
                  if(cantidadFixeada == '0.00')
                    cantidadFixeada = '0'

                  let sku = {
                    confeccion: confeccionPrecio,
                    id: arti.id,
                    nombre: arti.descripcion,
                    sku: arti.sku,
                    descuento: parseInt(arti.descuento),
                    description: arti.descripcion,
                    qty: cantidadFixeada,
                    noimp: noimp
                  };

                  this.addNewItemInItemForm();
                  this.updateItemForm(contador, sku);

                  contador++;
                });

                //this.categoriaSelect = res.idCategoria;

                /*let addDescuento = false;

                invoiceData.value.items.forEach(item => {
                  item.precio = ponerMoneda(item.precio.toFixed(2),invoiceData.value.empresa.moneda)
                  item.total = ponerMoneda(item.total.toFixed(2),invoiceData.value.empresa.moneda)

                  if(item.descuento != 0)
                  {
                    addDescuento = true;
                  }
                  
                });
              
                if(addDescuento)
                {
                  columnas.splice(3, 0, "descuento");
                }

                invoiceData.value.total = ponerMoneda(invoiceData.value.total.toFixed(2),invoiceData.value.empresa.moneda);

                if(invoiceData.value.items.length % 29 == 0){
                  invoiceData.value.classbanco = "div-banco-separacion";
                }
                else{
                  invoiceData.value.classbanco = "";
                }        */

              });
          }
          else {
            //this.invoiceData.items = [];
            this.addNewItemInItemForm('Personalizado');
          }

          this.fechaSelect = new Date().toISOString().split('T')[0];

        });

    },
    addNewItemInItemForm(tipo = '') {
      this.$refs.form.style.overflow = 'hidden'
      let item = JSON.parse(JSON.stringify(this.itemFormBlankItem));
      this.invoiceData.items.push(item);

      if (tipo != '')
        this.updateItemForm(this.invoiceData.items.length - 1, this.articulosSku[0])

      ///console.log(item);

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight)
        setTimeout(() => {
          this.$refs.form.style.overflow = null
        }, 350)
      })
    },
    removeItem(index) {
      this.invoiceData.items.splice(index, 1)
      this.trTrimHeight(this.$refs.row[0].offsetHeight)
    },
    initTrHeight(restar = 0) {
      this.trSetHeight(null)
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight - restar)
      })
    },
    obtenerNumero(codigoRectificativa = '') {
      if ((!this.cargandoFactura && this.empresaSelect.id != null && this.categoriaSelect.id != null && this.fechaSelect != null && this.fechaSelect != '' && this.nuevaFactura) || codigoRectificativa != '') {
        let dataSend = {
          empresa: this.empresaSelect.id,
          categoria: this.categoriaSelect.id,
          fecha: this.fechaSelect.split('-')[0]
        }

        axios
          .post("/finanzas/factura/codigo", dataSend)
          .then(response => {
            return response.data;
          })
          .then(res => {
            if (codigoRectificativa != '')
              this.codigoFactura = res.codigo + '-' + codigoRectificativa;
            else
              this.codigoFactura = res.codigo;
          });
      }

    },
    resetFactura() {

      this.clientSelect = null;
      this.empresaSelect = { nombre: '', direccion: '', direccion2: '', direccion3: '', cif: '', moneda: '' };
      this.fechaSelect = null;
      this.categoriaSelect = { nombre: '', codigo: '' };
      for (let i = this.invoiceData.items.length - 1; i >= 0; i--) {
        this.removeItem(i);
      }
      this.addNewItemInItemForm('Personalizado');
      this.retencion = 0;
      this.iva = 21;
      this.shipping = 0;
      this.codigoFactura = "";
      this.facturaCreada = false;
    },
    guardarFactura() {

      let error = false;

      if (this.empresaSelect.id == null) {
        this.$bvToast.toast(`No se ha seleccionado la empresa.`, {
          title: 'Faltan datos',
          variant: 'danger',
          solid: true,
        })

        error = true;
      }

      if (this.clientSelect == null) {
        this.$bvToast.toast(`No se ha seleccionado el cliente.`, {
          title: 'Faltan datos',
          variant: 'danger',
          solid: true,
        })

        error = true;
      }

      if (this.fechaSelect == null) {
        this.$bvToast.toast(`No se ha seleccionado la fecha.`, {
          title: 'Faltan datos',
          variant: 'danger',
          solid: true,
        })

        error = true;
      }

      if (this.categoriaSelect.id == null) {
        this.$bvToast.toast(`No se ha seleccionado la categoria.`, {
          title: 'Faltan datos',
          variant: 'danger',
          solid: true,
        })

        error = true;
      }

      if (this.invoiceData.items.length == 0 || (this.invoiceData.items.length == 1 && this.invoiceData.items[0].total == 0)) {
        this.$bvToast.toast(`No has añadido ningun producto`, {
          title: 'Faltan datos',
          variant: 'danger',
          solid: true,
        })
        error = true;
      }

      if (error)
        return;

      this.invoiceData.empresa = this.empresaSelect.id;
      this.invoiceData.client = this.clientSelect.id;

      this.invoiceData.retencion = this.retencion;
      this.invoiceData.iva = this.iva;
      this.invoiceData.shipping = this.shipping;
      this.invoiceData.codigo = this.categoriaSelect.codigo + this.codigoFactura;
      this.invoiceData.categoria = this.categoriaSelect.id;
      this.invoiceData.fecha = this.fechaSelect;
      this.invoiceData.moneda = this.empresaSelect.moneda;

      this.invoiceData.subtotal = this.subtotal;
      this.invoiceData.descuentototal = this.descuentototal;

      this.invoiceData.idDireccionEnvio = this.clientSelectEnvio.id

      if (this.retencion > 0)
        this.invoiceData.retenciontotal = this.retenciontotal;
      else
        this.invoiceData.retenciontotal = 0;

      if (this.iva > 0)
        this.invoiceData.ivatotal = this.ivatotal;
      else
        this.invoiceData.ivatotal = 0;

      this.invoiceData.items.forEach(itemInvoice => {
        if (itemInvoice.descuento == undefined)
          itemInvoice.descuento = 0;
      });

      this.invoiceData.idFacturaDraft = '';

      if (this.facturaRectificativa && (this.motivoDevolucion == null || this.motivoDevolucion == '')) {
        this.$bvToast.toast(`Debe seleccionar un motivo de devolución para la factura rectificativa.`, {
          title: 'Faltan datos',
          variant: 'danger',
          solid: true,
        })

        return;
      }
      else if (this.facturaRectificativa) {
        this.invoiceData.motivoDevolucion = this.motivoDevolucion;
        this.invoiceData.idFacturaRectificada = this.facturaCargada.id;
      }
      else {
        this.invoiceData.motivoDevolucion = '';
        this.invoiceData.idFacturaRectificada = 0;
      }

      if (!this.cargandoFactura || this.facturaRectificativa) {

        if (this.facturaDraft) {
          this.invoiceData.idFacturaDraft = this.articulosParametros.split('-')[0];
        }

        axios
          .post("/finanzas/factura", this.invoiceData)
          .then(response => {
            return response.data;
          })
          .then(res => {
            let idFactura = res.insertId;
            this.facturaCreada = true;

            //Aqui ocultar la factura de draft

            this.$swal({
              icon: 'success',
              title: 'La factura se ha creado correctamente: ' + this.invoiceData.codigo,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            })

            if (this.articulosParametros != undefined && Array.isArray(this.articulosParametros) && this.articulosParametros.length > 0 && this.pendientes.length == 0) {

              let items = [];


              this.articulosParametros.forEach(articulo => {

                let articuloEncontrado = this.invoiceData.items.filter(item => item.sku.id === articulo.id);

                if (articuloEncontrado.length > 0) {
                  items.push({
                    factura: this.categoriaSelect.codigo + this.codigoFactura,
                    fecha: this.fechaSelect,
                    id: articulo.id
                  })
                }
                else {
                  articuloEncontrado = this.invoiceData.items.filter(item => item.sku.sku === articulo.sku);

                  if (articuloEncontrado.length > 0) {
                    items.push({
                      factura: this.categoriaSelect.codigo + this.codigoFactura,
                      fecha: this.fechaSelect,
                      id: articulo.id
                    })
                  }

                }
              });

              if (items.length > 0) {

                axios
                  .post("/finanzas/pendiente/finalizar", items)
                  .then(response => {
                    return response.data;
                  })
                  .then(res => {
                    this.$router.push('/factura');
                  })
              }
            }
            else if (this.pendientes != undefined && Array.isArray(this.pendientes) && this.pendientes.length > 0) {
              let items = [];

              this.pendientes.forEach(articulo => {
                items.push({
                  cantidadFacturada: articulo.cantidadFacturada,
                  cantidad: articulo.cantidad,
                  finalizado: articulo.finalizado,
                  id: articulo.id
                });
              });

              this.articulosParametros.forEach(articulo => {
                articulo.idFactura = idFactura;
                articulo.codigoFactura = this.categoriaSelect.codigo + this.codigoFactura;
              });

              const promesas = [];

              if (items.length > 0) {
                promesas.push(
                  axios.post("/finanzas/pendiente/actualizar/facturado", items)
                );
              }

              promesas.push(
                axios.post("/finanzas/factura/tracking", { items: this.articulosParametros })
              );

              Promise.all(promesas)
                .then(() => {
                  this.$router.push("/factura");
                })
                .catch(err => {
                  console.error("Error en alguna de las peticiones:", err);
                  this.$bvToast.toast(`Se ha creado la factura, pero se ha producido un error al actualizar los pendientes.`, {
                    title: 'Error al actualizar',
                    variant: 'danger',
                    solid: true,
                  });
                });


              /*let items = [];

              this.pendientes.forEach(articulo => {
                items.push({
                  cantidadFacturada: articulo.cantidadFacturada,
                  cantidad: articulo.cantidad,
                  finalizado: articulo.finalizado,
                  id: articulo.id
                })
              });

              if(items.length > 0){

                axios
                .post("/finanzas/pendiente/actualizar/facturado", items)
                .then(response => {
                  return response.data;
                })
                .then(res => {
                  this.$router.push('/factura');
                  })
              }

              this.articulosParametros.forEach(articulo => {
                articulo.idFactura = idFactura;
                articulo.codigoFactura = this.categoriaSelect.codigo+this.codigoFactura;
              });

              axios
                .post("/finanzas/factura/tracking",  {items: this.articulosParametros})
                .then(response => {
                  return response.data;
                })
                .then(res => {
                this.$router.push('/factura');
                })*/

            }
            else {
              this.$router.push('/factura');
            }

          }).catch(error => {

            this.$bvToast.toast(`Es posible que el codigo de factura ya exista.`, {
              title: 'Error al crear la factura',
              variant: 'danger',
              solid: true,
            })
          })

      }
      else {
        this.invoiceData.idFactura = this.facturaCargada.id;

        axios
          .put("/finanzas/factura", this.invoiceData)
          .then(response => {
            return response.data;
          })
          .then(res => {
            this.$swal({
              icon: 'success',
              title: 'La factura se ha actualizado correctamente: ' + this.invoiceData.codigo,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            })

            this.$router.push('/factura');
          })
          .catch(err => {
            this.$bvToast.toast(`Se ha producido un error en el servidor.`, {
              title: 'No se ha actualizado.',
              variant: 'danger',
              solid: true,
            })
            console.log(err);
          });
      }

    },
    agregarNuevoCliente() {
      let data = {
        nombre: this.customer.nombre,
        cif: this.customer.cif,
        email: this.customer.email,
        direccion: this.customer.direccion,
        ciudad: this.customer.ciudad,
        cp: this.customer.cp,
        provincia: this.customer.provincia,
        pais: this.customer.pais,
        tlf: this.customer.tlf,
        iso: this.customer.iso
      }

      if (!this.editandoDireccion) {

        axios
          .post("/finanzas/cliente", data)
          .then(response => {
            return response.data;
          })
          .then(res => {
            this.showSidebar = false;
            this.$swal({
              icon: 'success',
              title: 'Cliente agregado correctamente: ' + this.customer.nombre,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            })

            this.lastCif = JSON.parse(JSON.stringify(this.customer.cif));

            this.customer.nombre = "";
            this.customer.cif = "";
            this.customer.email = "";
            this.customer.direccion = "";
            this.customer.ciudad = "";
            this.customer.cp = "";
            this.customer.provincia = "";
            this.customer.pais = "";
            this.customer.tlf = "";
            this.customer.iso = "";

            this.loadData();
          });
      } else {

        data.id = this.customer.id;

        axios
          .put("/finanzas/cliente", data)
          .then(response => {
            return response.data;
          })
          .then(res => {
            this.showSidebar = false;
            this.editandoDireccion = false;
            this.$swal({
              icon: 'success',
              title: 'Cliente actualizado correctamente: ' + this.customer.nombre,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            })

            this.lastCif = JSON.parse(JSON.stringify(this.customer.cif));

            this.customer.nombre = "";
            this.customer.cif = "";
            this.customer.email = "";
            this.customer.direccion = "";
            this.customer.ciudad = "";
            this.customer.cp = "";
            this.customer.provincia = "";
            this.customer.pais = "";
            this.customer.tlf = "";
            this.customer.iso = "";

            this.loadData();
          });

      }
    },
    agregarNuevaDireccionEnvio() {

      let data = {
        nombre: this.customerEnvio.nombre,
        cif: this.customerEnvio.cif,
        direccion: this.customerEnvio.direccion,
        ciudad: this.customerEnvio.ciudad,
        cp: this.customerEnvio.cp,
        provincia: this.customerEnvio.provincia,
        pais: this.customerEnvio.pais,
        tlf: this.customerEnvio.tlf,
        idCliente: this.clientSelect.id
      }

      if (!this.editandoDireccionEnvio) {

        axios
          .post("/finanzas/cliente/envio", data)
          .then(response => {
            return response.data;
          })
          .then(res => {
            this.showSidebarEnvio = false;
            this.$swal({
              icon: 'success',
              title: 'Direccion de envio agregada correctamente: ' + this.customerEnvio.nombre,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            })

            //this.lastCif = JSON.parse(JSON.stringify(this.customer.cif));

            this.customerEnvio.nombre = "";
            this.customerEnvio.cif = "";
            this.customerEnvio.email = "";
            this.customerEnvio.direccion = "";
            this.customerEnvio.ciudad = "";
            this.customerEnvio.cp = "";
            this.customerEnvio.provincia = "";
            this.customerEnvio.pais = "";
            this.customerEnvio.tlf = "";

            this.loadData();
          });
      }
      else {

        data.id = this.customerEnvio.id;

        axios
          .put("/finanzas/cliente/envio", data)
          .then(response => {
            return response.data;
          })
          .then(res => {
            this.showSidebarEnvio = false;
            this.editandoDireccionEnvio = false;
            this.$swal({
              icon: 'success',
              title: 'Direccion de envio actualizada correctamente: ' + this.customerEnvio.nombre,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            })


            this.customerEnvio.nombre = "";
            this.customerEnvio.cif = "";
            this.customerEnvio.email = "";
            this.customerEnvio.direccion = "";
            this.customerEnvio.ciudad = "";
            this.customerEnvio.cp = "";
            this.customerEnvio.provincia = "";
            this.customerEnvio.pais = "";
            this.customerEnvio.tlf = "";

            this.loadData();
          });
      }

    },
    ponerMoneda(total) {
      if (this.empresaSelect.moneda == "€")
        return total + '' + this.empresaSelect.moneda
      else
        return this.empresaSelect.moneda + '' + total;
    },
    getTotalLine(data) {
      let cantidad = data.qty;
      if (cantidad == "" || cantidad == "0")
        cantidad = 1;

      let total = data.precio * cantidad;

      let totalDescuento = 0;

      // Parsear el descuento a un número
      if (data.descuento != undefined && data.descuento != '') {
        let descuentoNum = parseFloat(data.descuento);

        if (!isNaN(data.descuento)) {
          total -= descuentoNum;
          totalDescuento = descuentoNum;
        } else {
          totalDescuento += (descuentoNum * total) / 100;;
          total -= (descuentoNum * total) / 100;
        }
      }

      if (isNaN(total))
        total = 0;
      else
        total = parseFloat(total.toFixed(2));

      data.total = total;

      data.totalDescuento = totalDescuento;

      this.comprobarDescuentoGeneral();

      return this.ponerMoneda(total);
    },
    comprobarDescuentoGeneral() {

      let descuento = false;

      this.invoiceData.items.forEach(item => {
        if (item.totalDescuento > 0)
          descuento = true;
      });

      this.hayDescuento = descuento;

    },
    getSubTotal() {
      let total = 0;

      this.invoiceData.items.forEach(item => {
        let cantidad = item.qty;
        if (cantidad == "" || cantidad == "0")
          cantidad = 1;

        total += (item.precio * cantidad);
      });

      if (isNaN(total))
        total = 0;
      else
        total = parseFloat(total.toFixed(2));

      this.invoiceData.subTotal = total;

      this.subtotal = this.ponerMoneda(total);

      return this.subtotal;

    },
    getDescuento() {
      let total = 0;
      this.invoiceData.items.forEach(item => {
        total += item.totalDescuento;
      });

      if (isNaN(total))
        total = 0;
      else
        total = parseFloat(total.toFixed(2));

      this.invoiceData.descuento = -total;

      this.descuentototal = this.ponerMoneda(total);

      return this.descuentototal;

    },
    getRetencion() {
      let total = 0;
      this.invoiceData.items.forEach(item => {
        if (!item.noimp)
          total += item.total;
      });

      total = (this.retencion * total) / 100;

      if (isNaN(total))
        total = 0;
      else
        total = parseFloat(total.toFixed(2));

      this.invoiceData.retencionCantidad = -total;

      this.retenciontotal = this.ponerMoneda(total);

      return this.retenciontotal;
    },
    getIva() {

      let total = 0;
      this.invoiceData.items.forEach(item => {
        if (!item.noimp)
          total += item.total;
      });

      total = (this.iva * total) / 100;

      if (isNaN(total))
        total = 0;
      else
        total = parseFloat(total.toFixed(2));

      this.invoiceData.iva = total;

      this.ivatotal = this.ponerMoneda(total);

      return this.ivatotal;
    },
    getTotal() {

      let subtotal = 0;
      let descuento = 0;
      let iva = 0;
      let retencion = 0;

      this.invoiceData.items.forEach(item => {
        let cantidad = item.qty;
        if (cantidad == "" || cantidad == "0")
          cantidad = 1;

        subtotal += (item.precio * cantidad);
        descuento += item.totalDescuento;

        if (!item.noimp) {
          iva += (this.iva * ((item.precio * cantidad) - item.totalDescuento)) / 100;
          retencion += (this.retencion * ((item.precio * cantidad) - item.totalDescuento)) / 100;
        }

      });

      //iva = (this.iva *(subtotal-descuento)) / 100;      
      //retencion = (this.retencion *(subtotal-descuento)) / 100;

      let total = 0;
      total = subtotal - descuento + iva - retencion + parseFloat(this.shipping);

      if (isNaN(total))
        total = 0;
      else
        total = parseFloat(total.toFixed(2));

      this.invoiceData.total = total;

      return this.ponerMoneda(total);

    },
    nuevoClienteModal() {
      this.customer.nombre = '';
      this.customer.cif = '';
      this.customer.email = '';
      this.customer.direccion = '';
      this.customer.ciudad = '';
      this.customer.cp = '';
      this.customer.provincia = '';
      this.customer.pais = '';
      this.customer.tlf = '';
      this.customer.iso = '';

      this.editandoDireccion = false;
      this.showSidebar = true;
    },
    editAddresClient() {

      this.customer.id = this.clientSelect.id;
      this.customer.nombre = this.clientSelect.nombre;
      this.customer.cif = this.clientSelect.cif;
      this.customer.email = this.clientSelect.email;
      this.customer.direccion = this.clientSelect.direccion;
      this.customer.ciudad = this.clientSelect.ciudad;
      this.customer.cp = this.clientSelect.cp;
      this.customer.provincia = this.clientSelect.provincia;
      this.customer.pais = this.clientSelect.pais;
      this.customer.tlf = this.clientSelect.tlf;
      this.customer.iso = this.clientSelect.iso;

      this.editandoDireccion = true;

      this.showSidebar = true;
    },
    nuevoClienteDireccionEnvioModal() {

      this.customerEnvio.nombre = '';
      this.customerEnvio.cif = '';
      this.customerEnvio.direccion = '';
      this.customerEnvio.ciudad = '';
      this.customerEnvio.cp = '';
      this.customerEnvio.provincia = '';
      this.customerEnvio.pais = '';
      this.customerEnvio.tlf = '';

      this.editandoDireccionEnvio = false;
      this.showSidebarEnvio = true;
    },
    editAddresEnvioClient() {

      this.customerEnvio.id = this.clientSelectEnvio.id;
      this.customerEnvio.nombre = this.clientSelectEnvio.nombre;
      this.customerEnvio.cif = this.clientSelectEnvio.cif;
      this.customerEnvio.direccion = this.clientSelectEnvio.direccion;
      this.customerEnvio.ciudad = this.clientSelectEnvio.ciudad;
      this.customerEnvio.cp = this.clientSelectEnvio.cp;
      this.customerEnvio.provincia = this.clientSelectEnvio.provincia;
      this.customerEnvio.pais = this.clientSelectEnvio.pais;
      this.customerEnvio.tlf = this.clientSelectEnvio.tlf;

      this.editandoDireccionEnvio = true;
      this.showSidebarEnvio = true;
    },
    openModalUps() {
      this.$bvModal.show("modal-ups-csv");
    },
    handleFileUpload(files) {
      if (files && files.length > 0) {
        this.adjuntos.push(...Array.from(files));
        this.archivosAdjuntosTemp = null;
      }
    },
    removeAttachment(index) {
      this.adjuntos.splice(index, 1);
    },
    async procesarCsvUps() {

      const getMonthNumber = (monthAbbrev) => {
          // Mapa de abreviaturas en español (puedes añadir más si es necesario)
          const months = {
              'ene': 1, 'feb': 2, 'mar': 3, 'abr': 4,
              'may': 5, 'jun': 6, 'jul': 7, 'ago': 8,
              'sep': 9, 'oct': 10, 'nov': 11, 'dic': 12
          };
          return months[monthAbbrev.toLowerCase()];
      };

      if (this.adjuntos.length === 0) {
        console.log('No hay archivos adjuntos para procesar.');
        return;
      }

      const resultados = [];
      const csvSplitRegex = /,(?=(?:(?:[^"]*"){2})*[^"]*$)/;

      for (const file of this.adjuntos) {
        try {
          const fileContent = await this.readFileContent(file);
          const lines = fileContent.split(/\r?\n/).filter(line => line.trim() !== '');
          for (let index = 1; index < lines.length; index++) {
            const element = lines[index];

            const fields = element.split(csvSplitRegex).map(field => field.trim());

            const numRaw = fields.length > 0 ? fields[0] : null;
            const fechaRaw = fields.length > 2 ? fields[2] : null;
            let importeRaw = fields.length > 5 ? fields[5] : null;

            if (importeRaw) {
              importeRaw = importeRaw.replaceAll('€', '');
              importeRaw = importeRaw.replaceAll(' ', '');

              importeRaw = importeRaw.replaceAll('.', '');           
              importeRaw = importeRaw.replaceAll(',', '.');
              importeRaw = importeRaw.replace(/[^\d.]/g, '');
              importeRaw = importeRaw.replace(/^"|"$/g, '');
            }

          let fechaFormateada = fechaRaw;

            if (fechaRaw) {
                const parts = fechaRaw.split(' '); 
                const day = parts[0]; 
                const monthAbbrev = parts[1];
                const year = parts[2];

                const month = getMonthNumber(monthAbbrev);

                if (month) {
                    const dateObject = new Date(year, month - 1, day); 

                    const options = { day: '2-digit', month: 'long', year: 'numeric' };
                    fechaFormateada = dateObject.toLocaleDateString('es-ES', options); 
                    
                    const dia = fechaFormateada.substring(0, 2);
                    const resto = fechaFormateada.substring(3).trim();

                    fechaFormateada = `${dia} ${resto.charAt(0).toUpperCase()}${resto.slice(1)}`; 
                    fechaFormateada = fechaFormateada.replace(/ de (\w)/g, (match, p1) => ` de ${p1.toUpperCase()}`);
                } else {

                    fechaFormateada = fechaRaw; 
                }
            }

            resultados.push({
              num: numRaw ? numRaw.replace(/^"|"$/g, '') : null,
              fecha: fechaFormateada,
              importe: importeRaw ? importeRaw.replace(/^"|"$/g, '') : null,
            }); 
          }

        } catch (error) {
          console.error(`Error al leer el archivo ${file.name}:`, error);
          resultados.push({
            fileName: file.name,
            error: 'Error al leer el archivo',
          });
        }
      }

      if(this.invoiceData.items.length == 1 && this.invoiceData.items[0].precio == 0)
        this.invoiceData.items = [];

      resultados.forEach(linea => {
        let item = JSON.parse(JSON.stringify(this.itemFormBlankItem));
        item.precio = linea.importe.replaceAll(',', '.');
        item.qty = 0;
        item.description = `Factura nº ${linea.num} de ${linea.fecha}`;
        item.sku = {
          "confeccion": 0,
          "id": -1,
          "nombre": "",
          "sku": "Personalizado"
        }
        this.invoiceData.items.push(item);
      });

      this.adjuntos = [];
      this.archivosAdjuntosTemp = null;
      this.$bvModal.hide("modal-ups-csv");

    },

    // Nueva función auxiliar para leer el contenido del archivo
    readFileContent(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        // El formato 'text' es adecuado para CSV
        reader.readAsText(file);

        reader.onload = (event) => {
          resolve(event.target.result);
        };

        reader.onerror = (error) => {
          reject(error);
        };
      });
    }

  },
  watch: {
    empresaSelect() {
      this.obtenerNumero();
    },
    categoriaSelect() {
      this.obtenerNumero();
    },
    fechaSelect() {
      this.obtenerNumero();
    },
    invoiceData: {
      handler(va) {
        setTimeout(() => {
          this.initTrHeight();
        }, 300);

      },
      deep: true,
    },
    "invoiceData.items": function (newVal, oldVal) {
      /*if(this.lastLenght != this.invoiceData.items.length)
        this.initTrHeight(0);
      else
        this.initTrHeight(231);*/

      this.lastLenght = this.invoiceData.items.length;
    },
    clientSelect() {

      this.clientsEnvio = [
        { id: 0, nombre: 'Misma dirección factura' },
        ...this.allClientDirecciones.filter(c => c.idCliente === this.clientSelect.id)
      ];


      /*this.clientsEnvio = [{id:0, nombre: 'Misma dirección factura'}];

      if (res.idCliente === this.clientSelect.id) {
        this.clientsEnvio.push(res);
      }*/


      this.clientSelectEnvio = this.clientsEnvio[0];
    }
  },
  setup() {
    const itemFormBlankItem = {
      item: null,
      precio: 0,
      qty: 0,
      nombre: '',
      descuento: 0,
      noimp: false
    }

    const invoiceData = ref({
      codigo: '0001',
      client: null,
      //items: [JSON.parse(JSON.stringify(itemFormBlankItem))],
      items: [],
      note: '',
    })

    const updateItemForm = (index, val) => {

      const { confeccion, qty, nombre, descuento, noimp } = val
      let qtyParse = qty;
      if (qtyParse == undefined)
        qtyParse = 1;
      if (nombre == '')
        qtyParse = 0;

      invoiceData.value.items[index].precio = confeccion
      invoiceData.value.items[index].qty = qtyParse
      invoiceData.value.items[index].description = nombre
      invoiceData.value.items[index].descuento = descuento
      invoiceData.value.items[index].sku = val
      invoiceData.value.items[index].noimp = noimp
    }

    const customer = ref({
      id: 0,
      nombre: '',
      email: '',
      cif: '',
      direccion: '',
      ciudad: '',
      cp: '',
      provincia: '',
      pais: '',
      tlf: '',
      direccionShipping: '',
      ciudadShipping: '',
      cpShipping: '',
      provinciaShipping: '',
      paisShipping: '',
      iso: ''
    })

    const customerEnvio = ref({
      id: 0,
      nombre: '',
      cif: '',
      direccion: '',
      ciudad: '',
      cp: '',
      provincia: '',
      pais: '',
      tlf: '',
    })



    return {
      invoiceData,
      updateItemForm,
      itemFormBlankItem,
      customer,
      customerEnvio
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.invoice-add-wrapper {
  .add-new-client-header {
    padding: $options-padding-y $options-padding-x;
    color: $success;

    &:hover {
      background-color: rgba($success, 0.12);
    }
  }
}

// Boton guardar/actualizar flotante: siempre visible en pantalla
.factura-edit-floating-btn {
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1031;
  padding: 0 !important;
  width: auto;

  .btn {
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.25);
  }
}


@import "~@core/scss/base/pages/app-invoice.scss";
@import '~@core/scss/base/components/variables-dark';

.form-item-section {
  background-color: $product-details-bg;
}

.form-item-action-col {
  width: 27px;
}

.repeater-form {
  // overflow: hidden;
  transition: .35s height;
}

.v-select {

  &.item-selector-title,
  &.payment-selector {
    background-color: #fff;

    .dark-layout & {
      background-color: unset;
    }
  }
}

.dark-layout {
  .form-item-section {
    background-color: $theme-dark-body-bg;

    .row .border {
      background-color: $theme-dark-card-bg;
    }

  }
}

.btn-ups-csv:hover {
  cursor: pointer;
}
</style>